import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Us</h2>
            <h3 style={{ marginTop: '15px', marginBottom: '15px', fontSize: '1.5em', color: '#2c3e50' }}>
              A Tech Driven Industrial Raw Material Distribution with an Integrated Supply Chain Platform
            </h3>
            <p className="lead" style={{ fontSize: '1.1em', color: '#666', marginBottom: '24px' }}>
              Leading the way in Polymer Trading, Supply Chain & Logistics Excellence
            </p>
            
            <h3 style={{ marginTop: '10px', marginBottom: '20px', color: '#2c3e50' }}>
              BSB – A Legacy of Trust Since 1968
            </h3>

            <div className="about-timeline">
              <div className="timeline-item">
                <div className="timeline-year">1968 – 1978</div>
                <h4>Foundations in Agri-Commodity</h4>
                <p>
                  BSB's journey began in <strong>1968</strong> when <strong>Mr. Babulal Sakarchand Bhavsar (BSB)</strong> started an agri-commodity brokerage at APMC Prantij, Gujarat. A small trading desk steadily grew into wholesale agri trade and shifted to Ahmedabad in <strong>1978</strong>, evolving into a diversified commodity trading business.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">1995 – 2000</div>
                <h4>Next-Gen Expansion</h4>
                <p>
                  In <strong>1995</strong>, <strong>Mr. Nalinkant Bhavsar</strong> joined the legacy after completing his MBA (Finance), bringing a modern, global outlook. By <strong>2000</strong>, BSB had expanded into trading and brokerage of Polymers, Metals, Minerals, Chemicals, and various Industrial Raw Materials across India and global markets.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2005 – 2020</div>
                <h4>Global Network & Partnerships</h4>
                <p>
                  Between <strong>2005 and 2020</strong>, BSB built a strong international network across Japan, South Korea, Middle East, Europe, USA, Africa, Iran, Taiwan, and Vietnam, offering value-added trade services and sourcing solutions for global buyers and suppliers.
                </p>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2020 – 2026</div>
                <h4>BSB Fortrade Ecosystem</h4>
                <p>
                  To support international operations, <strong>BSB Fortrade FZE</strong> was established in the UAE in <strong>2020</strong>. The group further strengthened its structure by forming <strong>BSB Brokers LLP (2020)</strong> and <strong>BSB Fortrade Pvt Ltd (2024)</strong> with a clear vision to build a technology-driven Industrial Raw Material Distribution and Integrated Supply Chain Platform for the future.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

